/** WHATDO SERVICES */
/** WHATDO SERVICES */
/** WHATDO SERVICES */


// CREATE A WHATDO
export async function addNewWhatDo(uId, token, whatDo) {
  // return true if create is successful, or throws error.
  // console.log('*** WhatDoServices >> starting addNewWhatDo(uId, token, whatDo) ***', whatDo);

  // build the data
  const wd = {
    title: whatDo.title,
    description: whatDo.description,
    projects: [ ...whatDo.projects ],
  };
  // build the REST API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/whatdos/${uId}.json?auth=${token}`, {
    method: 'POST',
    body: JSON.stringify(wd),
  });
  const responseData = await response.json();

  // "err handling" - needs to be made real
  if (!response.ok) {
    throw new Error(response.message || 'Failed to add a new whatDo wheel');
  }
  return responseData;
}


// READ ALL WHATDO ITEMS
export async function getAllWhatDosFromDbase(uId, token) {
  // return an object of all whatDos, or null.
  // console.log('*** WhatDoServices >> starting getAllWhatDosFromDbase(uId, token) ***');

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/whatdos/${uId}.json?auth=${token}`);
  const responseData = await response.json();
  // console.log(responseData);

  // err-handling
  if(!response.ok) {
    throw new Error(response.message || 'Failed to add read all whatDos');
  }
  // return data
  return responseData || null;
}


// READ ONE WHATDO
export async function getOneWhatDoFromDbase(uId, token, wdId) {
  // returns a WhatDo object, or null
  // console.log('*** WhatDoServices >> starting getOneWhatDoFromDbase(wdId) ***', wdId);
  
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/whatdos/${uId}/${wdId}.json?auth=${token}`);
  const responseData = await response.json();

  if (!response.ok) {
    const error = new Error(response.message || 'Failed to get one whatDo');
    throw error;
  }

  return responseData;

}








// UPDATE A WHATDO's OPTIONS
export async function updateOneWhatDo(uId, token, wdId, whatDo) {
  // returns the just-updated whatDo object, or throws error
  // console.log('*** starting updateOneWhatDo(uId, token, whatDo) ***', wdId, whatDo);

  // response
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/whatdos/${uId}/${wdId}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(whatDo)
  });
  const responseData = await response.json();

  if (!response.ok) {
    // console.log(responseData);
    throw new Error(response.message || 'Failed to update a whatDo');
  } else {
    return responseData;
  }
}




// DELETE A WHATDO - return true if delete is successful, or error.
export async function deleteOneWhatDo(uId, token, wId ) {
  // console.log('*** starting deleteOneWhatDo(uId, token, wId) ***', wId);

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/whatdos/${uId}/${wId}.json?auth=${token}`, {
    method: 'DELETE',
  });
  const responseData = await response.json();

  if (!response.ok) {
    throw new Error(response.message || 'Failed to delete a whatDo');
  } else {
    return responseData;
  }
}


